import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties } from '../../../builder/types';
import StarRatings from '../../../../../components/starRatings/StarRatings';

interface IFillingRatingProps {
  properties: IProperties,
  name: string,
  values: any,
  disabled?: boolean,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}

export const FillingRating: React.FC<IFillingRatingProps> = ({ properties, values, setFieldValue, name, disabled }) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4} style={{userSelect: 'none'}}>
        <Text onClick={() => { }} fontWeight={500} style={{userSelect: 'none'}}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300} style={{userSelect: 'none'}}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flex={1}>
        <StarRatings 
        disabled={disabled} starSpacing="0px" starRatedColor="#f9a394" starEmptyColor={'#a29d9c'} rating={values[name]} numberOfStars={5}
          changeRating={(e) => {
            if (disabled) return
            setFieldValue(name, e)
          }} starDimension="18px" />
      </Flex>
    </Flex>);
}